jQuery(function ($) {
    $(document).ready(function () {
        /**
         * Hide/show list when title name is clicked.
         */
        $('.accordion-title').on('click', function () {
            let title = $(this);
            let content = title.next();

            const activeElements = $('.accordion-title.active');
            if (activeElements.length > 0 && !activeElements.is(title)) {
                activeElements.removeClass('active');
                activeElements.children().last().toggleClass('rotate-180')
                activeElements.next().addClass('opacity-0').addClass('invisible').addClass('h-0');
            }

            title.toggleClass('active');
            title.children().last().toggleClass('rotate-180');
            content.toggleClass('h-0').toggleClass('opacity-0').toggleClass('invisible').toggleClass('active');
        });
    });
})